import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../redux/store";


export const useNotifications = (
  service: (params: { limit: number; offset: number }) => Promise<any>,
  page: number,
  pageSize: number
) => {
  const [notifications, setNotifications] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const notificationCount = useSelector((state: RootState) => state.notificationRefresh);
  
  const dispatch = useDispatch();

  const fetchNotifications = async () => {
    setLoading(true);
    try {
      const { code, data } = await service({
        limit: pageSize,
        offset: page * pageSize,
      });
      if (code === 200 && data) {
        setNotifications(data);
        // dispatch(setNotificationCount(data)); // optional, you may want to control when to dispatch based on tab
      } else {
        setNotifications([]);
      }
    } catch (err: any) {
      setError(err.message || "Failed to fetch notifications");
      setNotifications([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNotifications();
  }, [page, pageSize, service,notificationCount]); // IMPORTANT: `service` in dependency

  return { notifications, setNotifications, loading, error, refetch: fetchNotifications };
};
